import Image from 'next/image'

import { cn } from '@/legacy-src/lib/utils'

const Bubble: React.FC<{
  imgUrl?: string
  className?: string
  sizeClass?: string
  children?: React.ReactNode
}> = ({ children, imgUrl, className, sizeClass = 'w-12 h-12' }) => {
  return (
    <div className={cn(`relative`, sizeClass, className)}>
      {imgUrl && (
        <Image
          sizes="128px"
          className={cn('overflow-hidden')}
          fill
          src={imgUrl}
          alt="image cover"
          style={{
            objectFit: 'cover',
            maskImage: "url('/images/ellipsis-rebrand.svg')",
            maskPosition: 'center',
            maskRepeat: 'no-repeat',
          }}
        />
      )}
      {children}
    </div>
  )
}

export default Bubble
